// Client wrappers for the Telegram alert endpoints
// (spec CLAUDE_CODE_TELEGRAM_ALERTS.md).
//
// Same contract as src/lib/sms.js: fire-and-forget, never awaited in a way
// that can block or fail the user's action, and the payload is only an id —
// each Netlify Function re-reads the row server-side with the service role
// and de-duplicates in telegram_alerts_sent.
//
// Nothing here is visible to the customer: no toast, no error surfaced.

import { supabase } from './supabase'

async function post(fn, payload) {
  try {
    const { data: sessionData } = await supabase.auth.getSession()
    const token = sessionData?.session?.access_token
    if (!token) {
      // Signed out (or session not established yet) — the scheduled
      // check-idle-signups job is the safety net for signups.
      // eslint-disable-next-line no-console
      console.info(`[alert:${fn}] skipped — no session`)
      return { skipped: 'no_session' }
    }
    const res = await fetch(`/.netlify/functions/${fn}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      // eslint-disable-next-line no-console
      console.warn(`[alert:${fn}]`, res.status, data)
    }
    return data || {}
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[alert:${fn}] fetch failed`, err?.message || err)
    return { error: 'network' }
  }
}

/** Alert 1 — a new account was created. */
export function notifySignup(profileId) {
  if (!profileId) return Promise.resolve({ skipped: 'no_id' })
  return post('notify-new-signup', { profile_id: profileId })
}

/** Alert 3 — a new order was booked (customer or staff). */
export function notifyNewOrder(orderId) {
  if (!orderId) return Promise.resolve({ skipped: 'no_id' })
  return post('notify-new-order', { order_id: orderId })
}

/** Alert 4 — an order was just marked paid (admin only endpoint). */
export function notifyPayment(orderId) {
  if (!orderId) return Promise.resolve({ skipped: 'no_id' })
  return post('notify-payment', { order_id: orderId })
}
